import { ComponentProps, useState } from 'react'
import { ModeToggle } from './components/mode-toggle'
import { useTheme } from './components/theme-provider'
import { Button } from './components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from './components/ui/card'
import { cn } from './lib/utils'
import { Separator } from '@/components/ui/separator'
import { Playground } from './playground/playground'
import { DiscordLogoIcon } from '@radix-ui/react-icons'
import posthog from 'posthog-js'

posthog.init('phc_CzgrC8hWXpKdVINX16Ep0kGlDehFctpfxjsiZ7VLfDf', {
  api_host: 'https://app.posthog.com',
})

const CodeText = (props: ComponentProps<'span'>) => {
  return (
    <span
      {...props}
      className={cn(
        props.className,
        'bg-muted text-muted-foreground rounded font-mono text-sm p-1'
      )}
    />
  )
}

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted flex flex-col">
      <header className="w-full py-8 flex flex-col items-center justify-center gap-2">
        <div className="flex items-center gap-3">
          <img src="/logo.svg" alt="Logo" className="h-10 w-10 rounded-lg shadow" />
          <h1 className="text-3xl font-bold tracking-tight">RefactorMe</h1>
        </div>
        <p className="text-muted-foreground text-lg max-w-xl text-center mt-2">
          Enhance your writing with our AI-powered refactoring tool. Avoid detection by AI detection tools.
        </p>
        <div className="flex gap-4 mt-4">
          <Button variant="outline" size="icon" asChild>
            <a href="https://discord.gg/QGspqyYS4Z" target="_blank" rel="noopener noreferrer">
              <DiscordLogoIcon className="h-6 w-6" />
            </a>
          </Button>
          <ModeToggle />
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-2 pb-8">
        <div className="w-full max-w-5xl">
          <Playground />
        </div>
      </main>
    </div>
  )
}

export default App
